import React  from 'react';
import { Chrono } from 'react-chrono';
import { Link, useNavigate } from 'react-router-dom';

const Timeline = ({ memoriesData }) => {
    const navigate = useNavigate();

    const items = memoriesData?.length > 0
        ? memoriesData
            .sort((b, a) => new Date(a.data.date) - new Date(b.data.date))
            .map(memory => {
                const memoryDate = new Date(memory.data.date);
                const isValidDate = !isNaN(memoryDate);
                return {
                    title: isValidDate
                        ? memoryDate.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
                        : "Date not specified.",
                    cardTitle: memory.data.name,
                    url: `/memory/${memory._id}`,
                    cardDetailedText: memory.data.description,
                    media: {
                        type: "IMAGE",
                        source: {
                            url: memory.data.gallery?.[0]?.media || "/images/logo/bardo-icon.png",
                        },
                    },
                };
            })
        : [];

    const handleLinkClick = (event, url) => {
        event.preventDefault(); 
        navigate(url); 
        window.scrollTo(0, 0);
    };

    return (
        <div style={{ width: '100%' }} >
            {items.length > 0 && <Chrono
                items={items.map(item => ({
                    ...item,
                    cardTitle: (
                        <Link href={item.url}
                            onClick={(event) => handleLinkClick(event, item.url)}
                            style={{ textDecoration: 'underline', color: '#112337', cursor: 'pointer' }}
                        >
                            {item.cardTitle}
                        </Link>
                    ),
                }))}
                mode="VERTICAL_ALTERNATING"
            /> || <>No memories added yet.</>}

        </div >
    );
};

export default Timeline;
